import * as Yup from "yup";

import { Strings } from "@app/constants";

export const fieldRequiredValidation = (field: string) => {
  return Yup.string()
    .required(Strings.validation.isRequired(field))
    .test(
      "no-leading-whitespace",
      `${field} should not start with white spaces`,
      (value) => (value ? !/^\s/.test(value) : false)
    );
};

export const emailValidation = () => {
  return Yup.string()
    .email(Strings.validation.invalidEmail)
    .required(Strings.validation.isRequired("Email"));
};
